<form autofocus [formGroup]="form">
    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form-dropdown
            formControlName="languageId"
            [labelText]="'Language' | translate"
            [codeListValues]="availableLanguages"></form-dropdown>
        <br />
        <label>{{ 'Changing the language will reload the page you are currently in. Continue?' | translate }}</label>
    </div>
    <div class="modal-footer">
        <button class="btn btn-sm btn-primary mr-2" (click)="save()">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
            &nbsp;&nbsp;{{ 'Save' | translate }}
        </button>
        <button class="btn btn-sm btn-secondary" (click)="activeModal.close(null)">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
            &nbsp;&nbsp;{{ 'Cancel' | translate }}
        </button>
    </div>
</form>
